import { Flex, Box, Button, Menu, MenuTrigger, MenuContent, MenuItem, Text } from '@cad-arc';
import { FooterDispatchArea } from '@mark43/cad-api';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Tooltip } from '../../common/components/tooltip';
import { useDispatchAreaStore } from '../../dispatch-areas/use-dispatch-areas';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { useFullscreenModalControls } from '../../modals/context/modal-context-provider';

function DispatchAreaLabel(props: { footerDispatchArea: FooterDispatchArea }): React.ReactElement {
    const dataAttributes = {
        'data-testid': 'footer-dispatch-area-label',
        'data-dispatch-area-owned': props.footerDispatchArea.dispatchAreaUserType === 'OWNER',
    };
    return (
        <Tooltip overlay={props.footerDispatchArea.label}>
            {props.footerDispatchArea.dispatchAreaUserType === 'OWNER' ? (
                <Text
                    {...dataAttributes}
                    variant="bodyMd"
                    fontWeight="bold"
                    noOfLines={1}
                    // @ts-expect-error arc types dont allow display=block but it works
                    display="block"
                    whiteSpace="nowrap"
                >
                    {props.footerDispatchArea.label}
                </Text>
            ) : (
                <Text
                    {...dataAttributes}
                    variant="bodyMd"
                    noOfLines={1}
                    // @ts-expect-error arc types dont allow display=block but it works
                    display="block"
                    whiteSpace="nowrap"
                >
                    {props.footerDispatchArea.label}
                </Text>
            )}
        </Tooltip>
    );
}

const DispatchAreaList = observer(() => {
    const store = useDispatchAreaStore();
    const modalControls = useFullscreenModalControls();
    const enabledFeatures = useEnabledFeatures();
    return (
        <Flex justifyContent="flex-end" gap="2" alignItems="center">
            <Menu>
                <MenuTrigger asChild>
                    <Button
                        variant="ghost"
                        data-testid="dispatch-areas-footer-button"
                        css={{ flexShrink: 0 }}
                    >
                        D-AREAS:
                    </Button>
                </MenuTrigger>
                <MenuContent side="top">
                    <MenuItem
                        data-testid="open-manage-dispatch-areas"
                        onSelect={() => {
                            modalControls.open({
                                type: 'MANAGE_DISPATCH_AREAS',
                                props: {},
                            });
                        }}
                    >
                        Manage D-Areas...
                    </MenuItem>
                    {enabledFeatures.ownDispatchAreas ? (
                        <MenuItem
                            onSelect={() => {
                                modalControls.open({
                                    type: 'SEND_DISPATCH_AREA',
                                    props: {},
                                });
                            }}
                        >
                            Send...
                        </MenuItem>
                    ) : undefined}
                </MenuContent>
            </Menu>
            {store.state.manageDispatchAreasView?.footerDispatchAreas.map((footerDispatchArea) => (
                <DispatchAreaLabel
                    footerDispatchArea={footerDispatchArea}
                    key={`${footerDispatchArea.dispatchAreaGroupId}~${footerDispatchArea.dispatchAreaId}`}
                />
            ))}
        </Flex>
    );
});

export function AppFooter() {
    return (
        <Box
            data-testid="app-footer"
            backgroundColor="surface.foreground"
            px="8px"
            justifyContent="end"
        >
            <DispatchAreaList />
        </Box>
    );
}
